import styled from '@emotion/styled';
import Loader from '@view/components/Loader';
import type { BEImageProps, FillType } from './BEImageProps';

const FIT_MAP = {
  cover: 'cover',
  contain: 'contain',
};

const Opacity = {
  strong: 0.8,
  medium: 0.4,
  weak: 0.1,
};

const fillStyle = (fillProp: FillType) => {
  if (fillProp === 'horizontal') {
    return 'width: 100%;';
  }
  if (fillProp === 'vertical') {
    return 'height: 100%;';
  }
  if (fillProp) {
    return `
      width: 100%;
      height: 100%;
    `;
  }
  return undefined;
};

function toPx(value: number | string): string {
  if (typeof value === 'number') {
    return `${value}px`;
  }
  return value;
}

export const StyledImageContainer = styled.div<BEImageProps>`
  display: flex;
  width: ${(props) => toPx(props.width || '100%')};
  height: ${(props) => toPx(props.height || '100%')};
  min-width: ${(props) => toPx(props.width || '100%')};
  min-height: ${(props) => toPx(props.height || '100%')};
  align-items: center;
  justify-content: center;
  background-color: #F1F3F4;
  border-radius: ${(props) => props.borderRadius};
  overflow: hidden;
  cursor: ${(props) => props.cursor || 'auto'};
`;

export const StyledImage = styled.img<BEImageProps>`
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
  user-select: none;

  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  -ms-user-drag: none;
  user-drag: none;

  overflow: hidden;
  object-fit: ${(props) => props.fit && FIT_MAP[props.fit]};
  width: 100%;
  height: 100%;
  ${(props) => props.fill && fillStyle(props.fill)}
  ${(props) =>
    props.opacity &&
    `opacity: ${
      props.opacity === true
        ? Opacity.medium
        : Opacity[props.opacity] || props.opacity
    };
  `}
`;

export const StyledLoader = styled(Loader)`
  position: absolute;
`;
